import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5c4d83a9")
const _hoisted_1 = { class: "card-user-detail" }
const _hoisted_2 = { class: "padding" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "center padding"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "user-info padding"
}
const _hoisted_9 = { class: "center title-1" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = {
  key: 0,
  class: "value positif"
}
const _hoisted_13 = {
  key: 1,
  class: "value negatif"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "edit-user"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_logo = _resolveComponent("base-image-logo")!
  const _component_base_control_grid = _resolveComponent("base-control-grid")!
  const _component_user_form_card = _resolveComponent("user-form-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.editing)
      ? (_openBlock(), _createBlock(_component_base_control_grid, {
          key: 0,
          sideWidth: 120
        }, {
          right: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.isSuperadmin)
                ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                    key: 0,
                    type: "delete",
                    class: "icon-button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteUser())),
                    title: _ctx.$t('delete')
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              (_ctx.canEdit)
                ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                    key: 1,
                    type: "edit",
                    class: "icon-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editing = true)),
                    title: _ctx.$t('edit')
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ])
          ]),
          left: _withCtx(() => [
            _createVNode(_component_base_image_logo, {
              src: _ctx.src,
              defaultSrc: "@/assets/default-user.png",
              canEdit: _ctx.canEditImage,
              onLoad: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveUserImage($event))),
              onDelete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteUserImage()))
            }, null, 8, ["src", "canEdit"])
          ]),
          middle: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("dig-ui-title", _hoisted_9, _toDisplayString(_ctx.user.username), 1),
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('User.email')) + " : ", 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.user.email), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('User.role')) + " : ", 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(`Roles.${_ctx.user.role}`)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.user.activated)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('activated')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.user.activated)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('desactivated')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.user.activated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("dig-ui-standard-button", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.askActivation())),
                          disabled: _ctx.loadingAskActivation
                        }, _toDisplayString(_ctx.$t('askActivation')), 9, _hoisted_15)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_user_form_card, {
            class: "form",
            title: _ctx.$t('editUser'),
            onValidate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateUser($event))),
            onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editing = false)),
            disabled: _ctx.disabledFormButton,
            user: _ctx.user
          }, null, 8, ["title", "disabled", "user"])
        ]))
      : _createCommentVNode("", true)
  ]))
}